export enum EntrypointTypes {
    NONE = "none",
}
